import { array, string, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';

/** Multi-select filter on a transaction's current drawing status (the Design
 *  Transactions report "barrel"). Generic string in-filter, like the others. */
export const DrawingStatus = struct({
	equalsType: EqualsType,
	values: array(string),
});
